import Dashboard from "../../common/components/layout/Dashboard";
import Toast from "../../common/components/ui/toast";
import { ToastProvider } from "../../common/components/ui/toast/toast.provider";
import TableLeads from "./components/table-leads/TableLeads";


function LeadsRegisterPage() {
  return (
    <ToastProvider>
      <Dashboard>
        <TableLeads />
      </Dashboard>
      <Toast />
    </ToastProvider>
  )
}

export default LeadsRegisterPage